export default __webpack_public_path__ + "static/media/assegura1.a399f437.png";